<template>
  <div>
    <div class="baic_content">
      <h3>基础信息</h3>

      <div class="bacle_input">
        <h5>考试名称:</h5>
        <el-input
          type="textarea"
          v-model.trim="textarea"
          maxlength="30"
          show-word-limit
          resize="none"
          class="check_textarea"
        >
        </el-input>
      </div>
      <div class="bacle_input" v-if="$route.name != 'Paperlist'">
        <h5>组卷模式:</h5>
        <el-input v-model.trim="input1" class="check_input" readonly></el-input>
        <el-tooltip class="item a" effect="darkts" placement="right">
          <div slot="content" class="prompt">
            请先选择组卷模式，再选择命题方式。
          </div>
        </el-tooltip>
      </div>
      <div class="bacle_input" v-if="$route.name != 'Paperlist'">
        <h5>命题方式:</h5>
        <el-input v-model.trim="input2" readonly class="check_input"></el-input>
        <el-tooltip class="item" effect="darkts" placement="right">
          <div slot="content" class="prompt">
            请先选择组卷模式，再选择命题方式。
          </div>
        </el-tooltip>
      </div>

      <!-- 按钮 -->
      <div class="operation">
        <el-button class="succ_btn" @click="backfor">返回</el-button>
        <el-button type="success" class="submit_btn" @click="examRepeat"
          >下一步</el-button
        >
      </div>
    </div>
    <!-- 提示小弹窗 -->
    <div class="delete_view">
      <el-dialog title="温馨提示" :visible.sync="lncompleteHint">
        <div class="delete_mian">
          <i class="iconfont icon-tishi1"></i>
          <p>{{ text }}</p>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="lncompleteHint = false">取 消</el-button>
          <el-button type="primary" @click="lncompleteHint = false"
            >确 定</el-button
          >
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import loginvuex from "@/store/index";
import { updateExamName, examIsExists } from "@/api/index.js";
export default {
  data() {
    return {
      textarea: "",
      input1: "", //组卷模式
      input2: "", //命题方式
      lncompleteHint: false, // 试卷名重复拦截弹窗
      text: "",
    };
  },
  props: ["cutcoms"],
  methods: {
    backfor() {
      this.$parent.back();
    },
    async examRepeat() {
      let ress = {
        examName: this.textarea, // 考试名称
        examType: "online",
        guid: JSON.parse(loginvuex.state.userlist).guid,
        userID: JSON.parse(loginvuex.state.userlist).userID,
        hid: JSON.parse(loginvuex.state.hid),
        examID: this.$parent.testinfomation.ExamID,
      };
      const isData = await examIsExists(ress);
      if (isData.status === 200) {
        if (isData.data.Data.count == 0) {
          // 如果试卷没有重复就去下一步
          this.cutcoms(1);
          this.$parent.testname = this.textarea;
        } else {
          // 如果重复了就去调修改试卷接口
          this.ModifyExam();
        }
      }
    },
    // 修改试卷
    async ModifyExam() {
      let res = {
        examID: this.$parent.testinfomation.ExamID,
        title: this.textarea, // 试卷名称
        guid: JSON.parse(loginvuex.state.userlist).guid,
        userID: JSON.parse(loginvuex.state.userlist).userID,
        hid: JSON.parse(loginvuex.state.hid),
      };
      const Data = await updateExamName(res);
      // if (Data.data.Status === 200) {
      //   this.cutcoms(1);
      // } else {
      //   this.text = Data.data.Data;
      // }
      if (Data.data.Status != 200) {
        this.text = Data.data.Data;
        this.lncompleteHint = true;
      }
    },
  },
  created() {
    this.input1 = this.$parent.testinfomation.PaperModeExam; //组卷模式
    this.input2 = this.$parent.testinfomation.PaperModeName; //组卷方式
    this.textarea = this.$parent.testinfomation.ExamName; //名字
  },
};
</script>

<style lang="scss" scoped>
.baic_content {
  background-color: white;
  //  margin-top: 24px;
  min-width: 1527px;
  padding-bottom: 50px;
  border-radius: 4px 4px 4px 4px;
  h3 {
    display: inline-block;
    width: 100%;
    height: 60px;
    background: #cce7ff;
    border-radius: 4px 4px 0px 0px;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: bold;
    line-height: 19px;
    color: #333333;
    padding-top: 17px;
    padding-left: 24px;
  }
  .bacle_input {
    display: flex;
    margin-top: 30px;
    padding-right: 40px;
    h5 {
      display: inline-block;
      min-width: 142px;
      font-size: 15px;
      font-family: PingFang SC;
      font-weight: 400;
      text-align: left;
      line-height: 40px;
      padding-left: 20px;
      &::before {
        content: "*";
        width: 20px;
        display: inline-block;
        color: #ff0000;
      }
      &:nth-child(3) {
        margin-left: 57px;
      }
    }
    .el-button {
      width: 162px;
      height: 40px;
      background: #1890ff;
      opacity: 1;
      border-radius: 4px;
      margin-left: 30px;
      color: #ffffff;
    }
  }
  .check_textarea {
    width: 825px;
    ::v-deep .el-textarea__inner {
      width: 825px;
      height: 40px;
      background: #ffffff;
      border: 1px solid #d9d9d9;
      opacity: 1;
      border-radius: 4px;
    }
  }
  .check_input {
    width: 632px;
    ::v-deep .el-textarea__inner {
      width: 632px;
      height: 40px;
      background: #ffffff;
      border: 1px solid #d9d9d9;
      opacity: 1;
      border-radius: 4px;
    }
  }
}
::v-deep .el-textarea .el-input__count {
  position: absolute;
  bottom: 12px;
  right: 18px;
}
::v-deep .el-textarea__inner {
  line-height: 28px !important;
}
.prompt {
  width: 147px;
  height: 28px;
  padding: 2px 1px;
}
.operation {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 341px 0 70px 0;
  .succ_btn {
    width: 162px;
    height: 50px;
    background: #eeeeee;
    color: #999999;
    margin-right: 90px;
  }
  .submit_btn {
    width: 162px;
    height: 50px;
    background: #0fc758;
    color: #ffffff;
  }
}
::v-deep .el-input__inner {
  border: 1px solid #dcdfe6;
}
// 弹窗
.delete_view {
  .title_box {
    // height: 54px;
    padding-bottom: 9px;
    margin-bottom: 20px;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: bold;
    line-height: 19px;
    color: #333333;
    border-bottom: 1px solid #abd7ff;
    // padding: 20px 24px 9px 24px;
    // padding-bottom: 9px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
  }
  ::v-deep .dialog-footer {
    margin-bottom: 30px;
  }
  ::v-deep.el-dialog__footer {
    justify-content: center !important;
  }
  span > button:nth-child(3) {
    margin-left: 50px;
  }
  ::v-deep .el-dialog__footer span > button:nth-child(2) {
    margin-left: 0;
  }
  .delete_mian {
    display: flex;
    // padding: 20px 0px;
    box-sizing: border-box;
    i {
      display: inline-block;
      //   width: 50px;
      font-size: 16px !important;
      color: #ffc664;
      text-align: center;
      // margin: 0 auto;
      margin-right: 10px;
      transform: translateY(4px);
    }
    p {
      text-align: left;
      font-size: 15px;
    }
  }

  .el-dialog__footer span > button {
    margin-top: 10px;
    &:nth-child(2) {
      margin-left: 30px;
    }
  }
}
::v-deep .delete_view .el-dialog {
  width: 300px;
  height: 200px;
  border-radius: 5px 5px 0px 0px;
  .input_layout {
    display: flex;
  }
}
::v-deep .el-dialog__header {
  height: 55px;
  background: linear-gradient(180deg, #64b5ff 0%, rgba(199, 228, 255, 1) 100%);
  opacity: 1;
  border-radius: 5px 5px 0px 0px;
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #333333;
}
::v-deep .el-dialog__wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
::v-deep .el-dialog__footer {
  padding: 0;
  display: flex;
  justify-content: center;
  align-content: center;
  text-align: center;
  span > button {
    width: 60px;
    height: 32px;
    opacity: 1;
    border-radius: 4px;
    padding: 0px;
    margin-top: 38px;
  }
}
</style>